import React, { ComponentProps, FunctionComponent } from "react";

const PhoneEndCallIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M1.64741 8.61751L0.370033 7.34013C0.250967 7.22203 0.157928 7.08031 0.0968765 6.92406C0.0358243 6.7678 0.00810581 6.60046 0.0154947 6.43273C0.0228828 6.26501 0.0652158 6.10061 0.139783 5.95006C0.21435 5.79952 0.319506 5.66614 0.448518 5.55847C1.90372 4.38801 3.61251 3.57466 5.43758 3.18378C7.12215 2.80668 8.86834 2.80495 10.5522 3.1787C12.384 3.56848 14.0974 4.38446 15.5536 5.56055C15.682 5.66763 15.7866 5.80032 15.8608 5.95017C15.9351 6.10003 15.9773 6.26376 15.9847 6.43094C15.9922 6.59812 15.9647 6.76509 15.9041 6.92122C15.8435 7.07734 15.7511 7.21921 15.6328 7.33778L14.3529 8.61769C14.1478 8.82678 13.8739 8.95433 13.5822 8.97658C13.2905 8.99882 13.0008 8.91424 12.7672 8.73861C12.3044 8.38384 11.8029 8.08265 11.2721 7.84078C11.0623 7.74578 10.8842 7.59257 10.759 7.39931C10.6338 7.20605 10.5667 6.98084 10.5657 6.75037L10.5667 5.66778C8.89341 5.20913 7.12641 5.21089 5.45216 5.67285L5.45109 6.75544C5.44957 6.98592 5.38202 7.21126 5.25643 7.40477C5.13084 7.59828 4.95248 7.75184 4.74249 7.84725C4.21126 8.09018 3.7091 8.39236 3.24558 8.74805C3.00916 8.92612 2.71571 9.01121 2.42104 8.98714C2.12637 8.96307 1.85104 8.83152 1.64741 8.61751Z",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M10 12L8 14M8 14L6 12M8 14L8 9",
      stroke: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(PhoneEndCallIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
